require('../modules/es6.regexp.constructor');
require('../modules/es6.regexp.to-string');
require('../modules/es6.regexp.flags');
require('../modules/es6.regexp.match');
require('../modules/es6.regexp.replace');
require('../modules/es6.regexp.search');
require('../modules/es6.regexp.split');
module.exports = require('../modules/_core').RegExp;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/es6/regexp.js
 ** module id = 348
 ** module chunks = 1
 **/